import React, {Fragment} from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";

import styles from './Breadcrumbs.module.css';
import { Icon } from "../Icon";

export interface BreadcrumbItem {
    title: string;
    link?: string;
}

interface BreadcrumbsProps {
    items: BreadcrumbItem[];
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
    const renderBreadcrumbItem = (item: BreadcrumbItem, index: number) => {
        const isLast = index === items.length - 1;
        const isClickable = !isLast && item.link;

        const content = isClickable ? (
            <Link to={item.link!} className={classNames(styles.breadcrumb, styles.link)}>
                {item.title}
            </Link>
        ) : (
            <span className={styles.breadcrumb}>
                {item.title}
            </span>
        );

        return (
            <Fragment key={item.link || index}>
                {content}
                {!isLast && <Icon name={'right'} className={styles.separator} />}
            </Fragment>
        );
    };

    return (
        <nav className={styles.breadcrumbs} aria-label="breadcrumb">
            {items.map(renderBreadcrumbItem)}
        </nav>
    );
};